import { pages } from 'common';
import { lazy } from 'react';
import MenuRoutes from './components/MenuRoutes';

const Apply = lazy(() => import('./pages/insurance/apply'));
const ApplyType = lazy(() => import('./pages/insurance/apply/[type]'));
const AuthCallbackPage = lazy(
  () => import('./pages/auth-callback/AuthCallbackPage')
);
const AuthSilentLoginPage = lazy(
  () => import('./pages/auth-silent-login/AuthSilentLoginPage')
);
const AuthSyncUserPage = lazy(
  () => import('./pages/auth-sync-user/AuthSyncUserPage')
);
const ContactUs = lazy(() => import('./pages/contact-us'));
const Faq = lazy(() => import('./pages/faq'));
const Home = lazy(() => import('./pages/home/home'));
const Lgm = lazy(() => import('./pages/insurance/lgm'));
const LgmQuote = lazy(() => import('./pages/insurance/lgm/LGMQuoter'));
const TermsAndConditions = lazy(() => import('./pages/terms-and-conditions'));
const LRPTerms = lazy(() => import('./pages/terms-and-conditions/lrp'));
const LgmScenarioAnalysis = lazy(
  () => import('./pages/insurance/lgm/scenario-analysis')
);
const LrpQuoter = lazy(() => import('./pages/insurance/lrp-quote/Quoter'));
const MediaViewer = lazy(() => import('./pages/media/MediaViewer'));
const MyCoverages = lazy(() => import('./pages/insurance/my-coverages'));
const Profile = lazy(() => import('./pages/profile'));
const Settings = lazy(() => import('./pages/settings'));
const SignIn = lazy(() => import('./pages/account/signin'));
const BreakevenCalculator = lazy(() => import('./pages/breakeven-calculator'));
const Watchlist = lazy(() => import('./pages/insurance/watchlist'));
const ApiKeys = lazy(() => import('./pages/api-keys'));
const AgentHub = lazy(() => import('./pages/agent/AgentHub'));
const Unsubscribe = lazy(() => import('./pages/unsubscribe'));
/* for debugging module not found errors */
const NotFound = lazy(
  () =>
    import(/* @vite-ignore */ `./pages/${window.__foo ? 'foo' : 'not-found'}`)
);

export const routes = [
  { element: Home, index: true },
  { element: AuthCallbackPage, path: pages.authCallback.path },
  { element: AuthSilentLoginPage, path: pages.authSilentLogin.path },
  { element: AuthSyncUserPage, path: pages.authSyncUser.path },
  {
    element: MediaViewer,
    path: `${pages.media.path}/:file`,
    accessRoles: [],
  },
  { element: Profile, ...pages.profile },
  { element: Settings, ...pages.settings, path: 'settings/*' },
  { element: SignIn, ...pages.signIn },
  { element: TermsAndConditions, ...pages.termsAndConditions },
  { element: LRPTerms, ...pages.lrpTerms },
  {
    element: MenuRoutes,
    children: [
      {
        element: Lgm,
        ...pages.lgm,
        children: [
          {
            element: LgmQuote,
            ...pages.lgmQuote,
          },
          {
            element: LgmScenarioAnalysis,
            ...pages.lgmQuoteScenarioAnalysis,
          },
        ],
      },
      { element: LrpQuoter, ...pages.lrpQuote },
      { element: MyCoverages, ...pages.coverage },
      { element: Watchlist, ...pages.watchlist },
      { element: BreakevenCalculator, ...pages.breakevenCalculator },
      { element: Apply, ...pages.apply },
      {
        element: ApplyType,
        path: `${pages.apply.path}/:type`,
        accessRoles: [],
      },
      { element: Faq, ...pages.faq },
      { element: ContactUs, ...pages.contactUs },
    ],
  },
  { element: ApiKeys, ...pages.apiKeys },
  { element: AgentHub, ...pages.agentDashboard, path: 'agent/*' },
  { element: Unsubscribe, ...pages.unsubscribeCampaign },
  { element: NotFound, title: 'Not Found', path: '/not-found' },
];
